import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Link, Container, Typography, Stack } from '@mui/material';
import useResponsive from '../../hooks/useResponsive';
import { PATH_AUTH } from '../../routes/paths';
import Page from '../../components/Page';
import Logo from '../../components/Logo';
import { RegisterForm } from '../../sections/auth/register';
import T from 'src/basic-components/text';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  padding: theme.spacing(3),
  justifyContent: 'space-between',
  // [theme.breakpoints.up('md')]: {
  //   alignItems: 'flex-start',
  //   padding: theme.spacing(7, 5, 0, 7),
  // },
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function RegisterPage() {
  const smUp = useResponsive('up', 'sm');

  return (
    <Page title="Register" hideAppbar>
      <RootStyle>
        <HeaderStyle>
          <Stack
            flex
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ width: '100%' }}
            gap={1}
          >
            {smUp && (
              <Typography variant="body2">
                <Stack flex flexDirection="row" alignItems="center" justifyContent="center" gap={1}>
                  <T>already-have-account</T>
                  <Link variant="subtitle2" component={RouterLink} to={PATH_AUTH.login}>
                    <T>login</T>
                  </Link>
                </Stack>
              </Typography>
            )}
            <Logo />
          </Stack>
        </HeaderStyle>
        <Container>
          <ContentStyle>
            <Typography sx={{ mb: 2 }}>
              <T>app-name</T>
            </Typography>

            <RegisterForm />

            {!smUp && (
              <Typography variant="body2" sx={{ mt: 3 }}>
                <Stack flex flexDirection="row" alignItems="center" justifyContent="center" gap={1}>
                  <T>already-have-account</T>
                  <Link variant="subtitle2" component={RouterLink} to={PATH_AUTH.login}>
                    <T>login</T>
                  </Link>
                </Stack>
              </Typography>
            )}
          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
